import {pascalCaseToKebab} from "../base.js"

import App from './App.vue'
import { createApp } from 'vue'

let appData = Object.assign({}, window[App.name+'Data']);
const app = createApp(App, appData);
app.mount('#'+pascalCaseToKebab(App.name))